// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetHotelClassificationBusinessesRequestModel from '../../model/get-hotel-classification-businesses-request-model';
import GetHotelClassificationBusinessesRequestDTO from '../dto/get-hotel-classification-businesses-request-dto';
import dtoSchema from '../schemas/get-hotel-classification-businesses-request-schema';

export default abstract class GetHotelClassificationBusinessesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetHotelClassificationBusinessesRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetHotelClassificationBusinessesRequestDTO>): GetHotelClassificationBusinessesRequestModel;
  static toModel(dto: DeepPartial<GetHotelClassificationBusinessesRequestDTO> | undefined | null): GetHotelClassificationBusinessesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetHotelClassificationBusinessesRequestDTO> | undefined | null): GetHotelClassificationBusinessesRequestModel | undefined {
    return dto ? new GetHotelClassificationBusinessesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetHotelClassificationBusinessesRequestModel> | GetHotelClassificationBusinessesRequestModel): GetHotelClassificationBusinessesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetHotelClassificationBusinessesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetHotelClassificationBusinessesRequestModel, can not map to GetHotelClassificationBusinessesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
